// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceGroupSupervisoryStatusContent,
  unionToDeviceGroupSupervisoryStatusContent,
  unionListToDeviceGroupSupervisoryStatusContent,
} from "./device-group-supervisory-status-content";
import {
  ElevatorGroupSupervisoryStatusMessage,
  ElevatorGroupSupervisoryStatusMessageT,
  verifyElevatorGroupSupervisoryStatusMessage,
} from "./elevator-group-supervisory-status-message";
import {
  EscalatorGroupSupervisoryStatusMessage,
  EscalatorGroupSupervisoryStatusMessageT,
  verifyEscalatorGroupSupervisoryStatusMessage,
} from "./escalator-group-supervisory-status-message";

export class GroupSupervisoryStatusMessage implements flatbuffers.IUnpackableObject<GroupSupervisoryStatusMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): GroupSupervisoryStatusMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsGroupSupervisoryStatusMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: GroupSupervisoryStatusMessage,
  ): GroupSupervisoryStatusMessage {
    return (obj || new GroupSupervisoryStatusMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsGroupSupervisoryStatusMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: GroupSupervisoryStatusMessage,
  ): GroupSupervisoryStatusMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new GroupSupervisoryStatusMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): DeviceGroupSupervisoryStatusContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? this.bb!.readUint8(this.bb_pos + offset)
      : DeviceGroupSupervisoryStatusContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startGroupSupervisoryStatusMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(
    builder: flatbuffers.Builder,
    messageType: DeviceGroupSupervisoryStatusContent,
  ) {
    builder.addFieldInt8(0, messageType, DeviceGroupSupervisoryStatusContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endGroupSupervisoryStatusMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createGroupSupervisoryStatusMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceGroupSupervisoryStatusContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    GroupSupervisoryStatusMessage.startGroupSupervisoryStatusMessage(builder);
    GroupSupervisoryStatusMessage.addMessageType(builder, messageType);
    GroupSupervisoryStatusMessage.addMessage(builder, messageOffset);
    return GroupSupervisoryStatusMessage.endGroupSupervisoryStatusMessage(builder);
  }

  unpack(): GroupSupervisoryStatusMessageT {
    return new GroupSupervisoryStatusMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceGroupSupervisoryStatusContent(
          this.messageType(),
          this.message.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: GroupSupervisoryStatusMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceGroupSupervisoryStatusContent(
        this.messageType(),
        this.message.bind(this),
      );
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): GroupSupervisoryStatusMessageT {
    const t = new GroupSupervisoryStatusMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceGroupSupervisoryStatusContent(
          this.messageType(),
          this.message.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class GroupSupervisoryStatusMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceGroupSupervisoryStatusContent = DeviceGroupSupervisoryStatusContent.NONE,
    public message:
      | ElevatorGroupSupervisoryStatusMessageT
      | EscalatorGroupSupervisoryStatusMessageT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return GroupSupervisoryStatusMessage.createGroupSupervisoryStatusMessage(
      builder,
      this.messageType,
      message,
    );
  }

  clone(): GroupSupervisoryStatusMessageT {
    const obj = new GroupSupervisoryStatusMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: GroupSupervisoryStatusMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyGroupSupervisoryStatusMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorGroupSupervisoryStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorGroupSupervisoryStatusMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorGroupSupervisoryStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorGroupSupervisoryStatusMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
